export default __webpack_public_path__ + "static/media/ic-unordered-list.630bce97.svg";